import React from "react"
import RichTextEditor from "./editor.component"
import { RichTextEditorProps } from "../types/richTextEditor/types"

const RichTextWrapper = (props: RichTextEditorProps) => {
    return <>
        <RichTextEditor {...props} />
    </>
}

export default RichTextWrapper


// WEBPACK FOOTER //
// ./src/common/rich-text/RichTextWrapper.tsx